// AUTO-GENERATED by scripts/convert-gallery.mjs — do not edit by hand.
import img01 from './realizacja-01.webp';
import img02 from './realizacja-02.webp';
import img03 from './realizacja-03.webp';
import img04 from './realizacja-04.webp';
import img07 from './realizacja-07.webp';
import img08 from './realizacja-08.webp';
import img09 from './realizacja-09.webp';
import img10 from './realizacja-10.webp';
import img11 from './realizacja-11.webp';
import img12 from './realizacja-12.webp';
import img13 from './realizacja-13.webp';
import img14 from './realizacja-14.webp';
import img15 from './realizacja-15.webp';
import img16 from './realizacja-16.webp';
import img17 from './realizacja-17.webp';
import img18 from './realizacja-18.webp';
import img19 from './realizacja-19.webp';
import img20 from './realizacja-20.webp';
import img21 from './realizacja-21.webp';
import img22 from './realizacja-22.webp';
import img23 from './realizacja-23.webp';
import img24 from './realizacja-24.webp';
import img25 from './realizacja-25.webp';
import img26 from './realizacja-26.webp';
import img27 from './realizacja-27.webp';
import img28 from './realizacja-28.webp';
import img29 from './realizacja-29.webp';
import img30 from './realizacja-30.webp';
import img31 from './realizacja-31.webp';
import img32 from './realizacja-32.webp';
import img33 from './realizacja-33.webp';
import img34 from './realizacja-34.webp';
import img35 from './realizacja-35.webp';
import img36 from './realizacja-36.webp';
import img37 from './realizacja-37.webp';
import img38 from './realizacja-38.webp';
import img39 from './realizacja-39.webp';
import img40 from './realizacja-40.webp';
import img41 from './realizacja-41.webp';
import img42 from './realizacja-42.webp';
import img43 from './realizacja-43.webp';
import img44 from './realizacja-44.webp';
import img45 from './realizacja-45.webp';
import img46 from './realizacja-46.webp';
import img47 from './realizacja-47.webp';
import img48 from './realizacja-48.webp';
import img49 from './realizacja-49.webp';

export const galleryImages: string[] = [
  img47,
  img48,
  img49,
  img01,
  img02,
  img03,
  img04,
  img07,
  img08,
  img09,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
];

